import { REQUEST_FOR_PAYMENT_DOCUMENT_TYPES } from "@/static/requestForPaymentDocumentTypes";

export default class GenerateOverdueDocumentRequest {
  contractorId!: string;
  documentType!: REQUEST_FOR_PAYMENT_DOCUMENT_TYPES;
  bankAccountId!: number;
  maturity!: number;
}
